import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { cacheKeys } from '../../cacheKeys';
import { QueryConfig } from '@/react-query';
import { GetTagsRequest, GetTagsResponse } from './getTags.types';
import { getTags } from './getTags.api';
import { useAppContext } from '@/context/context';
import { useEffect } from 'react';

type GetTagsOptions = QueryConfig<typeof getTags>;

const EMPTY_TAGS: GetTagsResponse['data'] = [] as GetTagsResponse['data'];

export function useTags(request?: GetTagsRequest, options: GetTagsOptions = {}) {
  const { setSnackbar } = useAppContext() || {};

  const { data, error, ...rest } = useQuery<GetTagsResponse, AxiosError<unknown>>({
    queryKey: cacheKeys.getTags(request),
    queryFn: async () => await getTags(request),
    staleTime: 5000,
    ...options
  });

  useEffect(() => {
    if (error && setSnackbar) {
      setSnackbar({ severity: 'error', message: 'אירעה שגיאה בטעינת תגיות', open: true });
    }
  }, [error, setSnackbar]);

  return { tags: data?.data || EMPTY_TAGS, error, data: data || ({} as GetTagsResponse), ...rest };
}
